export const PeriodOccurrencesEnum = {
  PONTO_INCOMPLETO: { description: 'Ponto Incompleto', code: 0 },
  FALTA_SEM_JUSTIFICATIVA: {
    description: 'Falta Sem Justificativa',
    code: 1,
  },
  FALTAS_JUSTIFICADAS: { description: 'Faltas Justificadas', code: 2 },
  ATRASOS_SEM_JUSTIFICATIVA: {
    description: 'Atrasos Sem Justificativa',
    code: 3,
  },
  ATRASOS_JUSTIFICADOS: { description: 'Atrasos Justificados', code: 4 },
  SAIDA_ANTECIPADA_SEM_JUSTIFICATIVA: {
    description: 'Saida Antecipada Sem Justificativa',
    code: 5,
  },
  SAIDA_ANTECIPADA_JUSTIFICADA: {
    description: 'Saida Antecipada Justificada',
    code: 6,
  },
  HORAS_EXTRAS_50: { description: 'Horas Extras 50%', code: 7 },
  HORAS_EXTRAS_60: { description: 'Horas Extras 60%', code: 8 },
  HORAS_EXTRAS_75: { description: 'Horas Extras 75%', code: 9 },
  HORAS_EXTRAS_80: { description: 'Horas Extras 80%', code: 10 },
  HORAS_EXTRAS_100: { description: 'Horas Extra 100%', code: 11 },
  HORAS_EXTRAS_140: { description: 'Horas Extra 140%', code: 12 },
  HORAS_EXTRAS_200: { description: 'Horas Extra 200%', code: 13 },
  HORAS_EXTRA_REFEICAO_100: {
    description: 'Horas Extra Refeição 100%',
    code: 14,
  },
  HORAS_EXTRA_REFEICAO_50: {
    description: 'Horas Extra Refeição 50%',
    code: 15,
  },
  HORAS_EXTRA_REFEICAO_60: {
    description: 'Horas Extra Refeição 60%',
    code: 16,
  },
  HORAS_EXTRA_REFEICAO_75: {
    description: 'Horas Extra Refeição 75%',
    code: 17,
  },
  HORAS_EXTRA_REFEICAO_80: {
    description: 'Horas Extra Refeição 80%',
    code: 18,
  },
  HORAS_TRABALHADAS: { description: 'Horas Trabalhadas', code: 19 },
  HORAS_ADICIONALNOTURNO: {
    description: 'Horas Adicional Noturno',
    code: 20,
  },
  HORAS_AFASTAMENTO: { description: 'Horas Afastamento', code: 21 },
  HORAS_ATESTADO: { description: 'Horas Atestado', code: 22 },
  HORAS_FERIAS: { description: 'Horas Ferias', code: 23 },
  HORAS_EXTRAS_50_NOTURNO: {
    description: 'Horas Extras 50% Noturno',
    code: 24,
  },
  HORAS_EXTRAS_60_NOTURNO: {
    description: 'Horas Extras 60% Noturno',
    code: 25,
  },
  HORAS_EXTRAS_75_NOTURNO: {
    description: 'Horas Extras 75% Noturno',
    code: 26,
  },
  HORAS_EXTRAS_80_NOTURNO: {
    description: 'Horas Extras 80% Noturno',
    code: 27,
  },
  HORAS_EXTRAS_100_NOTURNO: {
    description: 'Horas Extra 100% Noturno',
    code: 28,
  },
  HORAS_EXTRA_REFEICAO_100_NOTURNO: {
    description: 'Horas Extra Refeição 100% Noturno',
    code: 29,
  },
  HORAS_EXTRA_REFEICAO_50_NOTURNO: {
    description: 'Horas Extra Refeição 50% Noturno',
    code: 30,
  },
  HORAS_EXTRA_REFEICAO_60_NOTURNO: {
    description: 'Horas Extra Refeição 60% Noturno',
    code: 31,
  },
  HORAS_EXTRA_REFEICAO_75_NOTURNO: {
    description: 'Horas Extra Refeição 75% Noturno',
    code: 32,
  },
  TURNONAOINICIADO: { description: 'Turno Não Iniciado', code: 9991 },
  SEMMARCACAORECEBIDA: { description: 'Sem Marcação Recebida', code: 9992 },
  PRESENTES: { description: 'Presentes', code: 9993 },
  AFASTADOS: { description: 'Afastados', code: 9994 },
  FERIAS: { description: 'Férias', code: 9995 },
  FOLGA: { description: 'Folga', code: 9999 },
};

export const PENDING_OCCURRENCES_DESCRIPTION = [
  PeriodOccurrencesEnum.ATRASOS_SEM_JUSTIFICATIVA.description,
  PeriodOccurrencesEnum.FALTA_SEM_JUSTIFICATIVA.description,
  PeriodOccurrencesEnum.SAIDA_ANTECIPADA_SEM_JUSTIFICATIVA.description,
];
